import { useReducer, useCallback } from 'react';
import { IndexState, IndexAction } from '@/types';

const initialState: IndexState = {
  search: {
    query: '',
    region: 'nairobi',
  },
  ui: {
    loading: true,
    contentReady: false,
    initialRenderComplete: false,
    connectionStatus: 'fast',
  },
  auth: {
    termsCheckDone: false,
    recoveryMode: false,
  },
};

function indexReducer(state: IndexState, action: IndexAction): IndexState {
  switch (action.type) {
    case 'SET_SEARCH':
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload,
        },
      };
    case 'SET_UI_STATE':
      return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        },
      };
    case 'SET_AUTH_STATE':
      return {
        ...state,
        auth: {
          ...state.auth,
          ...action.payload,
        },
      };
    case 'RESET_STATE':
      return initialState;
    default:
      return state;
  }
}

export function useIndexState() {
  const [state, dispatch] = useReducer(indexReducer, initialState);

  const setSearch = useCallback((payload: Partial<IndexState['search']>) => {
    dispatch({ type: 'SET_SEARCH', payload });
  }, []);

  const setUIState = useCallback((payload: Partial<IndexState['ui']>) => {
    dispatch({ type: 'SET_UI_STATE', payload });
  }, []);

  const setAuthState = useCallback((payload: Partial<IndexState['auth']>) => {
    dispatch({ type: 'SET_AUTH_STATE', payload });
  }, []);

  const resetState = useCallback(() => {
    dispatch({ type: 'RESET_STATE' });
  }, []);

  return {
    state,
    setSearch,
    setUIState,
    setAuthState,
    resetState,
  };
} 